import { Component, OnDestroy, OnInit } from '@angular/core';
import { Chart } from 'chart.js';
import { DashboardService } from '../../services/dashboard.service';
import { CurrencyPipe } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-amount-spent',
  templateUrl: './amount-spent.component.html',
  styleUrl: './amount-spent.component.scss'
})
export class AmountSpentComponent implements OnInit, OnDestroy {
  constructor(private dashboardService: DashboardService, private currencyPipe: CurrencyPipe) { }
  formattedTotalSpend: string;
  chart: Chart<'pie', number[], unknown>;
  noDataAvailable: boolean;
  noData: boolean;
  totalSpentContent: string;
  curPurchaseContent: string;
  footerContent: string;
  private unsubscribe$ = new Subject<void>()

  ngOnInit(): void {
    this.dashboardService.buyerStatsData.pipe(takeUntil(this.unsubscribe$)).subscribe(result => {
    
      this.noData = !result.totalSpend;
      if (result.totalSpend > 0) {
        this.formattedTotalSpend = this.currencyPipe.transform(result.totalSpend, 'GBP', 'symbol', '1.2-2');
        this.totalSpentContent = `<div>${this.formattedTotalSpend}</div>`;
        this.curPurchaseContent = `<div>${result.curPurchases}</div>`;
        this.footerContent = `<div>Number of vehicles purchased</div>`;
      }
    })
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
